import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('product_pricing_status')
@doc.path('/product_pricing_statuses/{?id}')
export default class ProductPricingStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': Shop_ProductPricingStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_ProductPricingStatusReference;

	public get color() {
		switch (this.reference) {
			case 'closed':
				return 'red';
			case 'open':
				return 'green';
			case 'waiting':
				return 'blue';
		}
	}
}
